import React from 'react';
import './CTABanner.css';

export default function CTABanner() {
  return (
    <section className="cta-banner">
      <div className="cta-content">
        <h2>Ready to find your perfect home?</h2>
        <p>Join thousands of happy homeowners who found their dream property with PACompany.</p>
        <div className="cta-buttons">
          <button className="btn-cta-primary">Browse Properties</button>
          <button className="btn-cta-secondary">Talk to an Agent</button>
        </div>
      </div>
    </section>
  );
}
